import {
  fetchUserData,
  fetchFrontendVersion,
  fetchAnnouncementList,
} from '@/api/api.APP_TARGET';

const getUserData = ({ state, commit }) => {
  if (state.promise) return state.promise;
  const fetchPromise = fetchUserData().then((data) => {
    commit('SET_USER_DATA', data);
  });
  commit('SET_PROMISE', fetchPromise);
  return fetchPromise;
};

const setUserData = ({ commit }, payload) => {
  commit('SET_PROMISE', null);
  commit('SET_USER_DATA', payload);
};

const clearPromise = ({ commit }) => {
  commit('SET_PROMISE', null);
};

// eslint-disable-next-line no-empty-pattern
const getFrontendVersion = ({}) => {
  return fetchFrontendVersion();
};

const getAnnouncementList = ({ commit }) => {
  return fetchAnnouncementList().then((data) => {
    commit('SET_ANNOUNCEMENT_LIST', data);
  });
};

export default {
  getUserData,
  setUserData,
  clearPromise,
  getFrontendVersion,
  getAnnouncementList,
};
